<div class="download-container">
    <div class="download-body">
        <div class="download-container" [ngClass]="{'has-promotion': hasPromotion || hasTheme}">

            <app-download-progress class="col left-col download-progress"
                [ngClass]="{'promotionLoaded': state === 'loadingFinished', 'has-promotion':  hasPromotion || hasTheme}"
                [ngStyle]="{'height': promotionHeight + 'px'}" [hasPromotion]=" hasPromotion || hasTheme" [device]="device">
            </app-download-progress>

            <div class="col right-col" *ngIf="(hasPromotion || hasTheme) && !device.isMobile" [ngClass]="{'promotionLoaded': state === 'loadingFinished'}">
                <div class="placeholder">
                    <ng-container *ngIf="hasPromotion; else themeTemplate">
                        <app-smash-promotion [replay]="replay" [promotion]="promotion$ | async"></app-smash-promotion>
                    </ng-container>
                    <ng-template #themeTemplate>
                        <app-smash-reveal [theme]="(theme$ | async)"></app-smash-reveal>
                    </ng-template>
                </div>
            </div>

        </div>
    </div>
</div>